// 门户和场景共同方法存放 以后就不需要写两个地方了
import { getdepttiplist } from '@/port/admins/organizationUser'
import { cloneDeep } from 'lodash'
import { axiosBase } from '@/api/api'
import { adddefaultdesk, addspacedefaultdesk } from '@/port/common/schoolNews'
import { dealRolePermission } from './utils'
import { applyIsConditionAppen, findTreeNodeEnhanced } from '@/components/schoolInstrument/mixins/utils.js'
import { setParamsList } from '@/util/customData.js'
import { defineAsyncComponent } from 'vue'
import topMenuNav from '@/components/schoolInstrument/common/topMenuNav.vue'
import leftNavMenu from '@/components/schoolInstrument/common/leftMenuNav.vue'
import historyList from '../common/historyList.vue'
import VoiceToText from '@/components/common/voice/VoiceToText.vue'

export default {
  provide: {
    // isSpace: this.isSpace
  },
  data() {
    return {
      // - 拖拽数据
      layout: [],
      layoutWidth: 0,
      // 菜单模式对应的信息
      menuInfo: {
        isOpen: 'open',
        position: 'left',
        style: 'icon'
      },
      // 菜单的列表信息
      menuLayoutList: [],
      // 模式暂存
      model: {
        model: 'door',
        style: 'default'
      },
      navRoute: [],
      spaceid: this.$route.query.spaceid,
      upaceid: this.$route.query.upaceid,
      // 画布列表
      checkObjList: [],
      organizationType: [],
      // 二级活跃
      activeMenuItem: 0,
      // 一级活跃
      activeMenu: 0,
      saveLeft: 0,
      saveArea: undefined,
      isCustom: this.$route.path === '/customInstrument',
      isWebSite: Boolean(this.$route.query.skey),
      skey: this.$route.query.skey,
      menuHeight: undefined,
      historyLists: [],
      isAppenGridLayout: false
    }
  },
  components: {
    transaction: defineAsyncComponent(() => import('../component/transaction/index')),//- 办理概况
    detail: defineAsyncComponent(() => import('../component/detailInfo/clientView')),//- 明细栏
    textCpn: defineAsyncComponent(() => import('@/components/clientSide/instrument/common/text/index.vue')),//- 文本组件
    roll: defineAsyncComponent(() => import('../component/roll/index')),//- 滚动图
    boutique: defineAsyncComponent(() => import('../component/boutique/index')),//- 精品应用
    programa: defineAsyncComponent(() => import('../component/programa/index')),//- 应用栏目
    implant: defineAsyncComponent(() => import('../component/implant/index')),//- 菜单栏目
    mutual: defineAsyncComponent(() => import('../component/mutual/index')),//- 应用列表
    space: defineAsyncComponent(() => import('../component/space/index')),//- 空间组件
    inDetail: defineAsyncComponent(() => import('../component/inDetailed/index')),
    indicatorsBread: defineAsyncComponent(() => import('../component/indicatorsBread/index')),
    upOption: defineAsyncComponent(() => import('@/components/schoolInstrument/mixins/upOption.vue')),
    topMenuNav,
    leftNavMenu,
    historyList,
    VoiceToText
  },
  watch: {
    activeTopMenu: {
      handler(val) {
        this.handleLoopCheckObjList(val, this.activeTopChildMenu)
        this.getSaveLeft()
      }
    },
    activeTopChildMenu: {
      handler(val) {
        this.handleLoopCheckObjList(this.activeTopMenu, val)
        this.getSaveLeft()
      }
    },
    isCollapse: {
      handler() {
        setTimeout(() => {
          if (this.$refs.gridLayout) {
            for (const ele of this.$refs.gridLayout) {
              ele?.layoutUpdate()
              this.resetBoutique()
            }
          }
        }, 300);
      },
    },
  },
  mounted() {
    // 获取组织类型
    if (!this.isWebSite) {
      this.getOrganizationType()
    }
  },
  methods: {
    getLayoutList(item, citem) {
      if (item.model && item.model.model === 'menu') {
        return citem.layout
      } else {
        return item.layout
      }
    },
    changeHistoryList({ li, value, idx, activeIdx }, key = 'historyLists') {
      if (key === 'historyLists') {
        this.$set(this, 'historyLists', li)
      } else {
        const menuIdx = this.historyLists.findIndex(item => item.id === this.activeTotalMenu)
        if (menuIdx !== -1) {
          this.$set(this.historyLists[menuIdx], 'historyLists', li)
        }
      }
      let active = null
      if (value === 'left') {
        if (idx > activeIdx) {
          active = li[0]
        }
      } else if (value === 'right') {
        if (idx < activeIdx) {
          active = li[li.length - 1]
        }
      } else if (value === 'other') {
        if (idx !== activeIdx) {
          active = li[0]
        }
      }
      if (active) {
        if (this.$route.path === '/customInstrument') {
          this.openTopNav(active.info)
        } else {
          this.$emit('pageJump', active.info)
        }
      }
    },
    clearAll(key = 'historyLists') {
      if (key === 'historyLists') {
        if (this.historyLists.length === 1) return
        const one = this.historyLists[0]
        this.$set(this, 'historyLists', [one])
        if (this.$route.path === '/customInstrument') {
          this.openTopNav(one.info)
        } else {
          this.$emit('pageJump', one.info)
        }
      } else {
        const menuIdx = this.historyLists.findIndex(item => item.id === this.activeTotalMenu)
        if (menuIdx !== -1) {
          const li = this.historyLists[menuIdx].historyLists
          if (li.length === 1) return
          const one = li[0]
          this.$set(this.historyLists[menuIdx], 'historyLists', [one])
          this.handleMenuClick(one.info)
        }
      }
    },
    delHistory(idx, key = 'historyLists') {
      if (key === 'historyLists') {
        const list = this.historyLists
        if (list.length === 1) {
          this.$message.error('当前页面无法删除')
          return
        }
        let info = {}
        if (idx === list.length - 1) {
          info = list[idx - 1].info
        } else {
          info = list[idx + 1].info
        }
        const beforeInfo = list[idx].info
        this.historyLists.splice(idx, 1)
        if (beforeInfo.id === this.activeTopMenu || beforeInfo.parent_id === this.activeTopMenu) {
          if (this.$route.path === '/customInstrument') {
            this.openTopNav(info)
          } else {
            this.$emit('pageJump', info)
          }
        }
      } else {
        const menuIdx = this.historyLists.findIndex(item => item.id === this.activeTotalMenu)
        if (menuIdx !== -1) {
          const li = this.historyLists[menuIdx].historyLists
          let info = {}
          if (idx === li.length - 1) {
            info = li[idx - 1].info
          } else {
            info = li[idx + 1].info
          }
          li.splice(idx, 1)
          if (this.activeMenuItem === info.id) {
            this.handleMenuClick(info)
          }
        }
      }
    },
    clikHistory(item, key) {
      console.log(item, key,'asdasdsadsadsada')
      if (key === 'historyLists') {
        if (this.$route.path === '/customInstrument') {
          // 场景
          this.openTopNav(item.info)
        } else {
          this.$emit('pageJump', item.info)
        }
      } else {
        this.handleMenuClick(item.info)
      }
    },
    topMenuClick(menu) {
      if (menu.apply) {
        const c = menu.apply[0]
        this.handleMenuClick(menu, c, true)
      } else {
        this.handleMenuClick(menu, menu, true)
      }
    },
    handleTopLeftMenuClick (nav) {
      const p = this.menuLayoutList.find(item => item.id === this.activeMenu)
      this.handleMenuClick(p, nav, true)
    },
    async resetBoutique() {
      setTimeout(() => {
        const refs = this.$refs.boutiqueRef
        if (refs) {
          refs.forEach(item => {
            item.onResize()
          })
        }
      }, 300);
    },
    menuStepClick (type = 'prev') {
      const idx = this.topMenuList.findIndex(c => c.id === this.activeMenuItem)
      let menu = {}
      if (type === 'prev') {
        menu = this.topMenuList[idx - 1]
      } else {
        menu = this.topMenuList[idx + 1]
      }
      this.handleMenuClick(menu, menu)
    },
    isAppenMask(item) {
      const list = item.apply
      let flag = false
      if (list) {
        const idx = list.findIndex(c => c.id === this.activeMenuItem)
        if (idx !== -1) {
          flag = true
        }
      }
      return flag
    },
    openDictionary(info) {
      // 打开字典
      const val = cloneDeep(info)
      if (val.schoolId) delete val.schoolId;
      let str = typeof val.options === 'string' ? JSON.parse(val.options) : val.options
      str = str.join(',')
      val.options = str.replace(/,/g, '\n')
      this.$refs.upOption.viewDialog({ title: '编辑选项' }, val);
    },
    getAppenShow(list) {
      if (!list) return {}
      const chi = list.find(item => item.isAppenCol || item.isAppenCol === undefined)
      return chi
    },
    openTopNav(val) {
      const nav = this.$refs.headerZun
      if (!nav) {
        this.$message.error('请打开顶部导航栏')
        return
      }
      const layout = nav.layout
      const ref = `layout${layout}`
      const cnav = nav.$refs[ref]
      if (!cnav) return
      cnav.active(0, val)
    },
    async pageJump(val = {}) {
      const userInfo = JSON.parse(localStorage.getItem("user"))
      const id = this.customDeskId
      const customData = cloneDeep(this.$store.state.doorCustomDataObj[id] || this.$store.state.dashboardCustomData || []) // 当前页面的自定义参数
      const { type, page, paramsList, cpage } = val.insideInfo ? val.insideInfo : val
      // 页面跳转的时候有设置传参要修改值
      if ((type === 'top' || type === 'left') && paramsList && paramsList.length > 0 && customData.length > 0) {
        const _paramsList = cloneDeep(paramsList)
        _paramsList.forEach(iter => {
          const index = customData.findIndex(citer => citer.name === iter.currentParam)
          if (index !== -1) {
            // 兼容自定义
            if (iter.type === 'input') {
              customData[index].value = iter.currentParam
            } else {
              const title = iter.otherParam.split('_')[0]
              if (title && val.row && val.row[title] !== undefined) {
                customData[index].value = val.row[title]
              }
            }
          }
        })
        if (id) {
          this.$store.commit('changeDoorCustomDataObj', { id, value: customData });
        } 
        this.$store.commit('changeCustomData', { key: 'door', value: customData });
      }
      if (type === 'top') {
        // 顶部
        const list = this.checkObjList
        let flag = false
        let rootPage = page
        ourter: for (let index = 0; index < list.length; index++) {
          const ele = list[index];
          const clist = ele.lists
          if (clist.length > 0) {
            for (let j = 0; j < clist.length; j++) {
              const cele = clist[j]
              if (flag) break ourter
              if (cele.id === page.id) {
                rootPage = cloneDeep(cele)
                flag = true
              }
            }
          } else {
            if (flag) break
            if (ele.id === page.id) {
              flag = true
              rootPage = cloneDeep(ele)
            }
          }
        }
        if (flag) {
          if (cpage && Object.keys(cpage).length > 0) {
            let rootCpage = null
            for (const ele of rootPage.layout.menu.list) {
              if (ele.id === cpage.id) {
                rootCpage = cloneDeep(ele)
                break
              }
              if (ele.apply && ele.apply.length > 0) {
                for (const cele of ele.apply) {
                  if (cele.id === cpage.id) {
                    rootCpage = cloneDeep(cele)
                    break
                  }
                }
              }
            }
            if (!rootCpage) {
              this.$message.error('子页面未找到')
            } else {
              localStorage.setItem('cPage', JSON.stringify(rootCpage))
            }
          }
          if (this.$route.path === '/customInstrument') {
            this.openTopNav(rootPage)
          } else {
            this.$emit('pageJump', rootPage)
          }
        } else {
          this.$message.error('顶部导航未找到')
        }
      } else if (type === 'left') {
        // 菜单模式
        if (this.model.model !== 'menu') {
          this.$message.error('该门户不是菜单模式')
          return
        }
        let resultPage = page
        const menuList = this.menuLayoutList
        let flag = false
        ourter: for (let index = 0; index < menuList.length; index++) {
          const ele = menuList[index];
          const clist = ele.apply
          if (clist && clist.length > 0) {
            for (let j = 0; j < clist.length; j++) {
              const cele = clist[j]
              if (flag) break ourter
              if (cele.id === page.id) {
                resultPage = cloneDeep(cele)
                flag = true
              }
            }
          } else {
            if (flag) break
            if (ele.id === page.id) {
              resultPage = cloneDeep(ele)
              flag = true
            }
          }
        }
        if (flag) {
          if (userInfo && userInfo.isadmin < 3) {
            // 说明是管理员  直接跳转
            this.handleMenuClick(resultPage, resultPage)
          } else {
            // 不是管理员 判断是否有权限
            const obj = {
              menu: {
                list: [resultPage]
              }
            }
            const list = await this.handleMenuPower(obj)
            if (list.length === 0) {
              this.$message.error('该角色暂无权限')
            } else {
              this.handleMenuClick(list[0], list[0])
            }
          }
        } else {
          this.$message.error('左侧导航未找到')
        }
      } else if (type === 'door') {
        // 跳转门户
        const params = this.spaceid ? { spaceid: this.spaceid } : {}
        const _api = this.spaceid ? 'openapi/getuserspacedesks' : 'openapi/getuserdesks'
        const res = await axiosBase(params, _api)
        if (res.code === 0) {
          if (!res.data.openrole) {
            this.$message.error('未打开角色门户')
            return
          }
          const list = res.data.list
          if (list.length === 0) {
            this.$message.error('该用户未拥有角色门户')
            return
          }
          const idx = list.findIndex(item => item.customDeskId === page.customDeskId)
          if (idx === -1) {
            this.$message.error('该用户未拥有选择的角色门户')
            return
          }
          const _par = { customDeskId: page.customDeskId }
          let paramsLists = []
          // 页面入参
          if (paramsList && paramsList.length > 0) {
            paramsLists = setParamsList(paramsList, customData)
            if (paramsLists.length > 0) {
              sessionStorage.setItem('paramsList', JSON.stringify(paramsLists))
            }
          }
          await this.spaceid ? addspacedefaultdesk(_par) : adddefaultdesk(_par)
          window.location.reload()
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    layoutMountedEvent() {
      this.isAppenGridLayout = false
      this.getSaveLeft()
      // const refs = this.$refs.drageArea
      setTimeout(() => {
        let refs = null
        const isMenu = this.model.model === 'menu'
        if (isMenu) {
          refs = this.$refs.drageArea
        } else {
          refs = this.$refs.webdesign
        }
        if (refs) {
          let ele = null
          for (const ref of refs) {
            const computedStyle = getComputedStyle(ref)
            if (computedStyle.display !== 'none') {
              if (isMenu) {
                ele = ref
              } else {
                ele = ref.querySelector(`#drageArea-${ref.id}`)
              }
              break
            }
          }
          let maxEle = null
          for (const cele of this.layout) {
            if (maxEle && maxEle.y < cele.y) {
              maxEle = cele
            } else if (!maxEle) {
              maxEle = cele
            }
          }
          if (maxEle && !maxEle.isLock) {
            this.isAppenGridLayout = true
            return
          }
          if (!maxEle) {
            this.isAppenGridLayout = true
            return
          }
          const totalH = (maxEle.y + maxEle.h) * 10
          const containerH = ele.clientHeight
          if (containerH) {
            if (totalH > containerH) {
              const overH = totalH - containerH
              maxEle.h = maxEle.h - Math.floor(overH / 10)
            } else {
              const lackH = containerH - totalH
              maxEle.h = maxEle.h + Math.floor(lackH / 10)
            }
            for (const ele of this.layout) {
              if (ele.i === maxEle.i) {
                ele.h = maxEle.h - 0.5
              }
            }
          }
          this.isAppenGridLayout = true
        } else {
          this.isAppenGridLayout = true
        }
      }, 200);
    },
    setMenuHeight() {
      setTimeout(() => {
        const allH = window.innerHeight
        const menuImgRef = this.$refs.webdesignMenuImg
        if (menuImgRef && menuImgRef[this.activeMenuIdx]) {
          const imgH = menuImgRef[this.activeMenuIdx].getBoundingClientRect().height
          this.menuHeight = allH - imgH - 33
        }
      }, 500);
    },
    async getSaveLeft() {
      await this.$nextTick()
      this.setMenuHeight()
      let cRef = this.$refs.schoolMain
      if (this.usePage === 'customInstrument') {
        cRef = this.$refs.webContentRef
        if (Array.isArray(cRef)) {
          cRef = cRef[0]
        }
      }
      if (cRef) {
        this.conW = cRef.clientWidth
        const left = (cRef.clientWidth - 1440) / 2
        if (left > 0) {
          this.saveLeft = left
        } else {
          this.saveLeft = 0
        }
      }
    },
    async getOrganizationType() {
      // 组织类型
      const { data, code, msg } = await getdepttiplist({
        curpage: 1,
        pagesize: 9999
      })
      if (code === 0) {
        this.organizationType = data
      } else {
        this.$message.error(msg)
      }
    },
    getBgInfo(item) {
      const type = item.type
      if (type === 'column' || type === 'apply' || type === 'space') {
        let background = ''
        let bgInfo = null
        let bgTran = null
        if (type === 'column') {
          bgInfo = item.info.bgInfo
          bgTran = item.info.pcBgTran
        } else if (type === 'apply') {
          bgInfo = item.info.applyConfig.bgInfo
          bgTran = item.info.applyConfig.pcStyleSet.pcOther
        } else if (type === 'space') {
          bgTran = item.info.bgTran
          bgInfo = item.info.bgInfo
        }
        if (bgTran) {
          background = 'transparent'
        } else {
          return this.handleBgInfo(bgInfo)
        }
        return {
          background
        }
      }
    },
    handleBgInfo(bgInfo) {
      let background = null
      if (bgInfo) {
        const { radio } = bgInfo
        if (radio === 'imgurl') {
          const backgroundImage = `url(${this.$imgurl + bgInfo[radio]})`
          return {
            backgroundImage
          }
        } else {
          background = bgInfo.color
        }
      } else {
        background = '#fff'
      }
      return {
        background
      }
    },
    async handleLoopCheckObjList(id, cid) {
      this.layout = []
      this.resetMenuData()
      if (cid === 0) {
        for (const item of this.checkObjList) {
          if (item.id === id) {
            // 这边加个判断 是因为  由于这个安全区设置是很早的配置，现在换成每个导航都要有自己的安全区，原先的安全区配置就放在了首页这边，所以如果说没有设置首页的安全区的话，就直接拿全局的
            if (item.saveArea === undefined && item.id === 1) {
              this.saveArea = this.styleTemp.overAllStyle.saveArea
            } else {
              this.saveArea = item.saveArea
            }
            await this.handleGetLayoutInfo(item)
          }
        }
      } else {
        for (const item of this.checkObjList) {
          for (const citem of item.lists) {
            if (citem.id === cid) {
              this.saveArea = citem.saveArea
              await this.handleGetLayoutInfo(citem)
            }
          }
        }
      }
    },
    replaceHistory() {
      const idx = this.historyLists.findIndex(f => f.id === this.activeTotalMenu)
      if (this.model && this.model.model === 'menu') {
        if (idx !== -1) {
          const info = this.historyLists[idx].historyLists
          let historyIdx = -1
          if (this.activeMenu === this.activeMenuItem) {
            historyIdx = info.findIndex(f => f.id === this.activeMenu)
          } else {
            historyIdx = info.findIndex(f => f.id === this.activeMenuItem)
          }
          if (historyIdx !== -1) {
            const obj = {
              ...info[historyIdx],
              layout: this.layout,
            }
            this.$set(this.historyLists[idx].historyLists, historyIdx, obj)
          }
        }
      } else {
        if (idx !== -1) {
          const info = this.historyLists[idx]
          const obj = {
            ...info,
            layout: this.layout,
          }
          this.$set(this.historyLists, idx, obj)
        }
      }
    },
    updateConfig() {
      this.replaceHistory(this.activeTotalMenu)
    },
    addHistoryList(id, info) {
      const obj = {
        id,
        historyLists: [],
        name: info.column
      }
      obj.layout = this.layout
      obj.menuLayoutList = this.menuLayoutList
      obj.menuInfo = this.menuInfo
      obj.model = this.model
      obj.info = info
      if (this.styleTemp.overAllStyle.isOpenHistory) {
        const idx = this.historyLists.findIndex(f => f.id === id)
        if (idx === -1) {
          this.historyLists.push(obj)
        }
      } else {
        this.$set(this.historyLists, 0, obj)
      }
    },
    addMenuHistoryList(id, info) {
      this.$nextTick(() => {
        const obj = {
          id,
          name: info.name,
          layout: this.layout,
          info
        }
        const menuIdx = this.historyLists.findIndex(f => f.id === this.activeTotalMenu)
        if (menuIdx !== -1) {
          if (this.historyLists[menuIdx].menuInfo && this.historyLists[menuIdx].menuInfo.isOpenMenuHistory) {
            const idx = this.historyLists[menuIdx].historyLists.findIndex(f => f.id === id)
            if (idx === -1) {
              this.historyLists[menuIdx].historyLists.push(obj)
            }
          } else {
            this.$set(this.historyLists[menuIdx].historyLists, 0, obj)
          }
        }
      })
    },
    async handleMenuPower(info) {
      let menuList
      // 不是管理员 只有当前角色列表能查看
      menuList = await dealRolePermission({
        val: info.menu.list,
        roleList: this.roleList
      })
      menuList = menuList.filter(f => {
        if (f.apply) {
          f.apply = f.apply.filter(cf => !!cf.isPermissionAppen)
          if (f.apply.length !== 0) return true
        } else {
          return !!f.isPermissionAppen
        }
      })
      return menuList
    },
    async handleGetLayoutInfo(item) {
      // 处理配置信息
      const history = this.historyLists.find(f => f.id === item.id)
      if (history) {
        item = history.info
      }
      const _info = item.layout
      const customId = item.id
      const userInfo = JSON.parse(localStorage.getItem("user"))
      if (_info) {
        if (_info.model.model === 'menu') {
          // 如果说是菜单模式
          let menuList
          if (userInfo && userInfo.isadmin < 3) {
            // 管理员所有都能查看
            menuList = _info.menu.list
          } else {
            if (this.upaceid) {
              menuList = _info.menu.list
            }
            else {
              menuList = await this.handleMenuPower(_info)
            }
          }
          const id = this.customDeskId
          menuList = applyIsConditionAppen(menuList, cloneDeep(this.$store.state.doorCustomDataObj[id]))
          this.menuLayoutList = menuList
          this.menuInfo = _info.menu.info
          this.model = _info.model
          let cPage = localStorage.getItem('cPage')
          if (cPage) {
            cPage = JSON.parse(cPage)
            if (cPage.isClick && this.customDeskInfo && Object.keys(this.customDeskInfo).length !== 0) {
              // 判断为否是点击进入的
              cPage = null
            } else {
              const p = findTreeNodeEnhanced({ apply: menuList, id: null }, cPage.id, { idKey: 'id', childrenKey: 'apply' })
              if (!p) {
                cPage = null
              }
              localStorage.removeItem('cPage')
            }
          }
          this.addHistoryList(customId, item)
          if (menuList.length !== 0) {
            let cMenu = menuList[0]
            if (cPage) {
              const item = menuList.find(f => f.id === cPage.id)
              if (!item) {
                for (const ele of menuList) {
                  if (ele.apply) {
                    const citem = ele.apply.find(f => f.id === cPage.id)
                    if (citem) {
                      this.handleMenuClick(ele, citem)
                      break
                    }
                  }
                }
              } else {
                this.handleMenuClick(item, item)
              }
            } else {
              if (cMenu.apply) {
                let item = this.getAppenShow(cMenu.apply)
                this.handleMenuClick(cMenu, item)
              } else {
                let item = this.getAppenShow(menuList)
                this.handleMenuClick(item, item)
              }
            }
          }
        } else {
          // 门户模式
          this.handleApplyColumnPower(_info.door.layout)
          this.addHistoryList(customId, item)
        }
      }
    },
    handleApplyColumnPower(template) {
      if (!template) {
        this.layout = []
        return
      }
      // 查找需要权限的应用栏目进行空栏目删除
      for (let i = 0; i < template.length; i++) {
        const item = template[i]
        if (item.type === 'column' && item.access) {
          const arr = []
          if (item.info && item.info.list && item.info.list.length > 0) {
            for (let a = 0; a < item.info.list.length; a++) {
              if (
                item.info.list[a].childConfig &&
                item.info.list[a].childConfig.length > 0
              ) {
                arr.push(item.info.list[a])
              }
            }
          }
          template[i].info.list = arr
        }
      }
      this.layout = this.historyLayout(template)
    },
    historyLayout(template) {
      if (this.model && this.model.model === 'menu') {
        const history = this.historyLists.find(f => f.id === this.activeTotalMenu)
        if (history) {
          const chistory = history.historyLists
          if (this.activeMenu === this.activeMenuItem) {
            const info = chistory.find(f => f.id === this.activeMenu)
            if (info) {
              return info.layout
            }
          } else {
            const info = chistory.find(f => f.id === this.activeMenuItem)
            if (info) {
              return info.layout
            }
          }
        }
      } else if (this.model && this.model.model === 'door') {
        const history = this.historyLists.find(f => f.id === this.activeTotalMenu)
        if (history && history.layout && history.layout.length > 0) {
          return history.layout
        }
      }
      return template
    },
    handleMenuClick(menu, menuItem) {
      // 点击应用
      this.navRoute = []
      this.activeMenu = menu.id
      this.activeMenuItem = menu.id
      this.navRoute.push({ name: menu.name })
      if (menuItem && menu !== menuItem) {
        this.navRoute.push({ name: menuItem.name })
        this.activeMenuItem = menuItem.id
        this.layout = this.historyLayout(cloneDeep(menuItem.layout))
        this.addMenuHistoryList(menuItem.id, menuItem)
        if (!this.customDeskInfo || (this.customDeskInfo && Object.keys(this.customDeskInfo).length === 0) || !this.isCustom) {
          menuItem.isClick = true
          localStorage.setItem('cPage', JSON.stringify(menuItem))
        }
      } else {
        this.layout = this.historyLayout(menu ? cloneDeep(menu.layout) : [])
        if (!this.customDeskInfo || (this.customDeskInfo && Object.keys(this.customDeskInfo).length === 0) || !this.isCustom) {
          menu.isClick = true
          localStorage.setItem('cPage', JSON.stringify(menu))
        }
        this.addMenuHistoryList(menu.id, menu)
      }
      // 执行一下有无权限
      this.handleApplyColumnPower(this.layout)
    },
    resetMenuData() {
      this.menuInfo = {
        isOpen: 'open',
        position: 'left',
        style: 'icon'
      }
      console.log('asddadsasdsd')
      this.menuLayoutList = []
      this.model = {
        model: 'door',
        style: 'default'
      }
    },
    colorRgb(str = '#4e86ff', opacity) {
      var sColor = str.toLowerCase()
      if (sColor) {
        if (sColor.length === 4) {
          var sColorNew = '#'
          for (var i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
          }
          sColor = sColorNew
        }
        // 处理六位的颜色值
        var sColorChange = []
        // eslint-disable-next-line no-redeclare
        for (var i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
        }
        return 'rgba(' + sColorChange.join(',') + ',' + opacity + ')'
      } else {
        return sColor
      }
    },
  },
  computed: {
    handleBgStyle() {
      let bg = {}
      if (Object.prototype.hasOwnProperty.call(this.styleTemp.overAllStyle, 'backGroundInfo')) {
        switch (this.styleTemp.overAllStyle.backGroundInfo.radio) {
          case "image":
            bg.background = `url('${this.$url}${this.styleTemp.overAllStyle.backGroundInfo.imageUrl}') center top no-repeat`
            if (this.styleTemp.overAllStyle.bgPosition === 'cover') {
              bg.background = `url('${this.$url}${this.styleTemp.overAllStyle.backGroundInfo.imageUrl}') center top / 100% 100% no-repeat`
            }
            break;
          case "color":
            bg.backgroundImage = '';
            bg.backgroundColor = this.styleTemp.overAllStyle.backGroundInfo.color;
            break;
          default:
            bg.backgroundImage = '';
            bg.backgroundColor = '#f5f5f5';
            break;
        }
      }
      return bg
    },
    activeMenuIdx() {
      const idx = this.historyLists.findIndex(f => f.id === this.activeTotalMenu)
      return idx
    },
    themeColorRgb() {
      if (this.themeColor) {
        return this.colorRgb(this.themeColor, 0.1)
      } else {
        return ''
      }
    },
    topNavChildList() {
      if (this.menuInfo.position !== 'top') return false
      const list = this.menuLayoutList || []
      const li = list.find(f => f.id === this.activeMenu)
      const cli = list.find(f => f.id === this.activeMenuItem)
      if (cli) return false
      if (!li) return false
      return li.apply || []
    },
    handlerRadius() {
      return this.styleTemp.overAllStyle.compRadius === 'n' ? '0' : '4px'
    },
    maxWidthComputed() {
      const obj = { maxWidth: this.saveArea ? '1440px' : '' }
      return obj
    },
    isAppenMenuBtn() {
      let flag = false
      if (this.model.model === 'menu' && this.menuInfo.position === 'top' && this.menuInfo.topStyle === 'three') {
        flag = true
      }
      return flag
    },
    topMenuList () {
      const list = this.menuLayoutList
      const arr = []
      for (const item of list) {
        if (item.apply) {
          for (const citem of item.apply) {
            if (citem.isAppenCol || citem.isAppenCol === undefined) {
              arr.push(citem)
            }
          }
        } else {
          if (item.isAppenCol || item.isAppenCol === undefined) {
            arr.push(item)
          }
        }
      }
      return arr
    },
  }
}